import { ChevronDown, ChevronUp } from 'react-feather'
import { useState } from 'react'
import Close from '../../icons/Close'
import { useRouter } from 'next/router'
import { getTextColor, webalizeName } from '@/functions/common/helper'
import { setCurrentTag } from '@/redux/actions/tagAction'
import { useDispatch } from 'react-redux'
import HorizontalSlider from '@/ui/components/category/HorizontalSlider'

const RollableTags = ({ ...props }) => {
    const router = useRouter()
    let dispatch = useDispatch()

    const [full, setFull] = useState(false)

    const redirectToTagCategory = tag => {
        let branchName = router.query.branch
        dispatch(setCurrentTag(tag))
        router.push(`/${branchName}/${webalizeName(tag.label)}`)
    }

    let colorChange = props.color
    colorChange = colorChange === '#ffffff' ? '#000000' : '#ffffff'

    return (
        <div id={'catTopPage'}>
            <div className={' mx-auto flex flex-col w-full text-white'}>
                <div
                    className={
                        ' leading-none font-fk_screamer text-4xl xl:text-5xl 2xl:text-6xl text-center justify-center flex items-center hover:cursor-pointer pt-2 pb-3 xl:pb-4 2xl:pb-5'
                    }
                    style={{
                        backgroundColor: !props.color ? '#E30A18' : props.color,
                        color: props.color ? getTextColor(props.color) : 'white'
                    }}
                    onClick={() => setFull(!full)}
                >
                    {props.title}
                    <div style={{ backgroundColor: colorChange }} className={'rounded-full ml-4 mt-2 xl:mt-3 2xl:mt-4'}>
                        {full ? (
                            <ChevronUp color={props.color === null ? '#E30A18' : props.color} size={20} />
                        ) : (
                            <ChevronDown color={props.color === null ? '#E30A18' : props.color} size={20} />
                        )}
                    </div>
                </div>
                {full && (
                    <div className={'lg:container lg:mx-auto'}>
                        <div
                            className={
                                'lg:container lg:mx-auto bg-white text-turbo-primary flex  flex-col p-2 xs:p-5 text-center'
                            }
                        >
                            <div className={'rounded-full justify-end flex mb-2 xs:mb-5'}>
                                <div className={'hover:cursor-pointer'} onClick={() => setFull(!full)}>
                                    <Close
                                        color={
                                            props.color === null
                                                ? '#E30A18'
                                                : props.color === '#ffffff'
                                                ? 'black'
                                                : props.color
                                        }
                                    />
                                </div>
                            </div>
                            <div
                                className={
                                    'grid grid-cols-3 gap-2 xs:gap-5 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6'
                                }
                            >
                                {props.menu &&
                                    props.menu.map(tag => {
                                        return (
                                            <div
                                                key={tag.id}
                                                onClick={() => redirectToTagCategory(tag)}
                                                className={
                                                    ' shadow-container leading-none font-fk_screamer pt-2 pb-3 xl:pb-4 tracking-0-03em text-3xl 2xl:text-5xl hover:brightness-95 active:brightness-90 rounded-xl xl:rounded-2xl hover:cursor-pointer '
                                                }
                                                style={{
                                                    color: tag.color ? getTextColor(tag.color) : 'black',
                                                    backgroundColor: tag.color ? tag.color : 'white',
                                                    border: tag.color ? `1px solid ${tag.color}` : '1px solid black'
                                                }}
                                            >
                                                {tag.label}
                                            </div>
                                        )
                                    })}
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <HorizontalSlider categories={props.formattedMenu} color={props.color} tagsOpened={full} />
        </div>
    )
}
export default RollableTags
